/* global axios */
import ApiClient from './ApiClient';

class LiaIntegrationsAPI extends ApiClient {
  constructor() {
    super('lia_integrations', { accountScoped: true });
  }

  getProviders() {
    return axios.get(`${this.url}/providers`);
  }

  testConnection(id) {
    return axios.post(`${this.url}/${id}/test_connection`);
  }
}

export default new LiaIntegrationsAPI();
